import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import { MUTATION_ACKNOWLEDGE_RISK_SCORE } from "../graphql/mutations";
import { useApolloClient } from "@apollo/client";
import { toast } from "react-toastify";

export const PausePlayerSessionDialog = ({
  showModal,
  skin,
  pages,
  remainingMs = 0,
  onClose,
  player,
}) => {
  const { t } = useTranslation("");
  const apolloClient = useApolloClient();

  const formatTime = () => {
    if (!remainingMs || remainingMs <= 0) return "00:00";
    const totalSeconds = Math.floor(remainingMs / 1000);
    const minutes = Math.floor(totalSeconds / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (totalSeconds % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const acknowledgeRiskScore = async () => {
    //console.log(RGVType);
    const { errors, data } = await apolloClient.mutate({
      mutation: MUTATION_ACKNOWLEDGE_RISK_SCORE,
      variables: {
        eventType: "RG04",
        nickName: player.nickName,
      },
      errorPolicy: "all",
    });
    if (errors) {
      toast.error(errors[0].message, {
        position: "bottom-center",
      });
      return false;
    }
    if (data) {
      onClose?.();
    }
    return true;
  };

  const handleAgnoligement = () => {
    acknowledgeRiskScore();
  };

  return (
    <StyledModal isOpen={showModal}>
      <StyledModalBody
        pause
        register
        dangerouslySetInnerHTML={{
          __html: t("label_pause_player_session"),
        }}
      ></StyledModalBody>
      {remainingMs !== 0 && (
        <StyledModalBody register pause>
          {t("label_remaining_time") + ": " + formatTime()}
        </StyledModalBody>
      )}
      {remainingMs === 0 ? (
        <StyledModalFooter position>
          <StyledButton
            btnBold
            limit
            pub={skin === "pub"}
            onClick={handleAgnoligement}
          >
            {t("label_ok")}
          </StyledButton>
        </StyledModalFooter>
      ) : (
        <StyledModalFooter>
          <StyledButton
            btnBold
            limit
            pub={skin === "pub"}
            onClick={() => (window.location = pages["withdrawal"])}
          >
            {t("label_withdrawal")}
          </StyledButton>
          <StyledButton
            btnBold
            limit
            pub={skin === "pub"}
            onClick={() => (window.location = pages["my-limits"])}
          >
            {t("label_limits")}
          </StyledButton>
        </StyledModalFooter>
      )}
    </StyledModal>
  );
};
